import { render, staticRenderFns } from "./EmailOptOut.vue?vue&type=template&id=65f082c6"
import script from "./EmailOptOut.vue?vue&type=script&lang=js"
export * from "./EmailOptOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports